import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { isDesktop } from "react-device-detect";
import {
    AppBar, Toolbar, Box, InputBase, IconButton, Badge, Avatar, Tooltip,
    Paper, Typography, Dialog, ClickAwayListener, Divider
} from "@mui/material";
import {
    Search as SearchIcon, ShoppingCart, ChatBubbleRounded, Facebook, Twitter,
    WhatsApp, YouTube, Instagram, Call
} from "@mui/icons-material";
import Cart from "../Services/cart";
import Searchlinks from "../Utils/links";
import { getsessioncart, getsessionuser } from "../Utils/sessions";
import { Unreadmessagesurl } from "../Utils/urls";

// ─── Design tokens — kept consistent with the rest of the app ─────────────
const BRAND = '#900f20';
const INK = '#1c1a1a';
const MUTED = '#78726f';

const socials = [
    { icon: Facebook, href: "https://www.facebook.com/eazistey/", label: "Facebook" },
    { icon: Twitter, href: "https://twitter.com/eazistey", label: "Twitter" },
    { icon: WhatsApp, href: "https://wa.me/+254791412410", label: "WhatsApp" },
    { icon: YouTube, href: "https://www.youtube.com/@eazistey", label: "YouTube" },
    { icon: Instagram, href: "https://www.instagram.com/eazistey/", label: "Instagram" },
];

const Universalheader = ({ refresh }) => {

    const navigate = useNavigate()
    const user = getsessionuser();
    const cart = getsessioncart()


    const [showcart, setshowcart] = useState(false);

    const [results, setresults] = useState('');
    const [showsearchdiv, setshowsearchdiv] = useState(false);
    const [currenttime, setcurrenttime] = useState('');
    const [timetaken, settimetaken] = useState('');
    const [unread, setunread] = useState('');
    const [error2, seterror2] = useState('');

    const [showcartview, setshowcartview] = useState(false);


    useEffect(() => {
        getunreadmessages();
        checkshoppingcart()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refresh]);

    const checkshoppingcart = () => {
        if (cart?.length > 0) {
            setshowcart(true)
        }
    }



    const getunreadmessages = async () => {
        try {
            const response = await fetch(Unreadmessagesurl, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email: user?.email
                })
            });
            const json = await response.json();
            if (!json.message) {
                if (json.unread) {
                    setunread(json.unread);
                } else {
                    setunread("0");
                }
            } else {
                setunread("0");
            }
        } catch (error) {
            setunread("0");
        }
    };


    const onbrowse = (e) => {
        var currentDateTime = Date.now();
        setcurrenttime(currentDateTime);
        setresults('')
        seterror2(null)
        if (!e.target.value) {
            setshowsearchdiv(false)
        } else {
            const gh = Searchlinks(e.target.value);
            if (gh.length < 1) {
                setshowsearchdiv(true)
                seterror2("No results for the current search criteria")
            } else {
                var th = Date.now();
                settimetaken(getElapsed(th - currenttime));
                setshowsearchdiv(true)
                setresults(gh)
            }
        }
    }


    function getElapsed(time) {
        if (time < 1000) {
            return `${time} m/s`;
        } else if (time < 60000) {
            let s = time / 1000;
            let arr = s.toString().split(".");
            return `${arr[0]}s ${arr[1]} m/s`;
        }
        return `${time} m/s`;
    }

    return (
        <>
            <Dialog
                open={showcartview}
                onClose={() => setshowcartview(false)}
                maxWidth="xs"
                fullWidth
            >
                <Cart />
            </Dialog>

            <AppBar
                position="sticky"
                elevation={0}
                sx={{
                    bgcolor: 'white',
                    color: INK,
                    borderBottom: '1px solid rgba(28,26,26,0.08)',
                }}
            >
                <Toolbar sx={{ gap: 2, flexWrap: { xs: 'wrap', md: 'nowrap' }, py: { xs: 1, md: 0.5 } }}>

                    {/* Search */}
                    <ClickAwayListener onClickAway={() => setshowsearchdiv(false)}>
                        <Box sx={{ position: 'relative', flex: '1 1 260px', maxWidth: 420 }}>
                            <Paper
                                elevation={0}
                                sx={{
                                    display: 'flex', alignItems: 'center',
                                    border: '1px solid rgba(28,26,26,0.12)', borderRadius: '999px',
                                    px: 1.5, py: 0.5,
                                    transition: 'box-shadow .2s ease, border-color .2s ease',
                                    '&:focus-within': {
                                        borderColor: BRAND,
                                        boxShadow: '0 0 0 4px rgba(144,15,32,0.08)',
                                    },
                                }}
                            >
                                <InputBase
                                    onChange={(e) => onbrowse(e)}
                                    placeholder="Quick search"
                                    aria-label="Search"
                                    sx={{ flex: 1, fontSize: '0.9rem' }}
                                />
                                <IconButton
                                    onClick={onbrowse}
                                    size="small"
                                    aria-label="Search"
                                    sx={{ color: BRAND }}
                                >
                                    <SearchIcon fontSize="small" />
                                </IconButton>
                            </Paper>

                            {showsearchdiv && (
                                <Paper
                                    elevation={0}
                                    sx={{
                                        position: 'absolute', top: 'calc(100% + 8px)', left: 0, right: 0,
                                        zIndex: (theme) => theme.zIndex.appBar + 1,
                                        borderRadius: '16px', border: '1px solid rgba(28,26,26,0.08)',
                                        boxShadow: '0 16px 40px rgba(28,26,26,0.12)',
                                        maxHeight: 380, overflowY: 'auto', p: 2,
                                    }}
                                >
                                    <Typography sx={{ fontWeight: 700, color: INK, fontSize: '0.9rem', mb: 0.5 }}>
                                        Search results
                                    </Typography>
                                    <Typography variant="caption" sx={{ color: MUTED, display: 'block', mb: 1 }}>
                                        About {Array.isArray(results) && results.length} results ({timetaken})
                                    </Typography>
                                    {error2 && (
                                        <Typography sx={{ fontSize: 12, color: 'error.main', mb: 1 }}>
                                            {error2}
                                        </Typography>
                                    )}
                                    {Array.isArray(results) && results.map((val, key) => (
                                        <Box
                                            key={key}
                                            onClick={() => navigate(val.link)}
                                            sx={{
                                                px: 1, py: 1, borderRadius: '10px', cursor: 'pointer',
                                                '&:hover': { bgcolor: 'rgba(144,15,32,0.05)' },
                                            }}
                                        >
                                            <Typography sx={{ fontWeight: 700, fontSize: '0.88rem', color: INK }}>
                                                {val.title}
                                            </Typography>
                                            <Typography variant="body2" sx={{ color: MUTED, fontSize: '0.8rem' }}>
                                                {val.description}
                                            </Typography>
                                        </Box>
                                    ))}
                                </Paper>
                            )}
                        </Box>
                    </ClickAwayListener>

                    {/* Social + contact — desktop only */}
                    {isDesktop && (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, ml: 1 }}>
                            {socials.map(({ icon: Icon, href, label }) => (
                                <Tooltip title={label} key={label}>
                                    <IconButton
                                        component="a"
                                        href={href}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        size="small"
                                        aria-label={label}
                                        sx={{ color: MUTED, '&:hover': { color: BRAND } }}
                                    >
                                        <Icon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            ))}

                            <Divider orientation="vertical" flexItem sx={{ mx: 1.5, my: 1 }} />

                            <Box
                                component="a"
                                href="tel:+254791412410"
                                sx={{
                                    display: 'flex', alignItems: 'center', gap: 0.75,
                                    textDecoration: 'none', color: BRAND, fontWeight: 700, fontSize: '0.9rem',
                                }}
                            >
                                <Call fontSize="small" />
                                +254791412410
                            </Box>
                        </Box>
                    )}

                    <Box sx={{ flex: 1 }} />

                    {/* Cart / messenger / avatar */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        {showcart && (
                            <Tooltip title="Cart">
                                <IconButton onClick={() => navigate("/nav/cart")} aria-label="Cart">
                                    <Badge badgeContent={cart?.length} color="error">
                                        <ShoppingCart sx={{ color: BRAND }} />
                                    </Badge>
                                </IconButton>
                            </Tooltip>
                        )}

                        {user && (
                            <Tooltip title="Messages">
                                <IconButton onClick={() => navigate("/nav/chats")} aria-label="Messages">
                                    <Badge badgeContent={unread > 0 ? unread : 0} color="error">
                                        <ChatBubbleRounded sx={{ color: BRAND }} />
                                    </Badge>
                                </IconButton>
                            </Tooltip>
                        )}

                        {user?.url && (
                            <Tooltip title="My account">
                                <Avatar
                                    onClick={() => navigate("/nav/useraccount")}
                                    src={user.url}
                                    sx={{ width: 34, height: 34, cursor: 'pointer', border: '2px solid rgba(144,15,32,0.15)' }}
                                />
                            </Tooltip>
                        )}
                    </Box>
                </Toolbar>
            </AppBar>
        </>
    )
}

export default Universalheader;